import localeModule from './locale';
import playerModule from './player';

export default {
  locale: localeModule,
  player: playerModule,
};
